import React from 'react';

/**
 * primary loading text for `Spinner`
 */
export default function SpinnerTitle(props) {
	return <div className="d-flex justify-content-center spinner-text" {...props} />;
}

SpinnerTitle.defaultProps = {
	children: 'Loading...'
};
